module.exports = "<p>\r\n  dashboard-quickresend works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/dash-board/dashboard-quickresend/dashboard-quickresend.component.html
// module id = ./src/app/dash-board/dashboard-quickresend/dashboard-quickresend.component.html
// module chunks = main